<template>
  <header v-if="!isStc" class="h-12 flex justify-between px-3 py-2 bg-white">
    <div class="flex gap-2 items-center">
      <img class="w-32" src="../assets/logo-large.svg" />
      <span class="text-lg text-[#999999]">{{ envName }}</span>
    </div>

    <div class="relative flex items-center justify-center">
      <div class="flex justify-center items-center p-1 text-lg">
        <span class="px-0 py-1 uppercase text-xs text-black mr-2">
          {{ language }}
        </span>
        <img class="w-4 h-4" src="../assets/icons/arrow_down.svg" />
      </div>
      <select
        class="absolute top-0 right-0 opacity-0 h-12 uppercase mr-3 border-spacing-0"
        @change="changeLanguage($event)"
        v-model="language"
      >
        <option v-for="(lang, key) in languages" :key="key" :value="key">
          {{ lang }}
        </option>
      </select>
    </div>
  </header>
</template>

<script setup>
import { onMounted, ref } from "vue"
import { useI18n } from "vue-i18n"
import languages from '@/utils/supportedLanguages.js'

defineProps({
  isStc: Boolean,
})

const { locale } = useI18n()

const envName = ref("")
const language = ref("en")

onMounted(() => {
  envName.value = import.meta.env.VITE_APP_PAGE_HEADER
  const urlParams = new URLSearchParams(window.location.search)
  const queriedLanguage = urlParams.get('language')

  if (detectLanguage(queriedLanguage)) {
    locale.value = queriedLanguage
    language.value = queriedLanguage
  } else {
    const systemLanguage = window.navigator.language.split('-')[0]
    if (detectLanguage(systemLanguage)) {
      locale.value = systemLanguage
      language.value = systemLanguage
    } else {
      locale.value = 'en'
    }
  }
})

const detectLanguage = (langKey) => langKey in languages

const changeLanguage = (event) => {
  const langId = event.target.value
  locale.value = langId
}
</script>
